var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.668 211.489L283.828 211.479C274.606 211.479 267.131 218.953 267.131 228.175V294.89C267.131 304.11 274.606 311.586 283.827 311.586H401.433C388.555 345.007 364.519 372.996 333.853 390.78L384 477.589C464.442 431.066 512 349.437 512 258.059C512 245.048 511.041 235.747 509.123 225.274C507.665 217.317 500.757 211.489 492.668 211.489Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 411.826C198.446 411.826 148.202 380.38 121.217 333.847L34.411 383.881C78.586 460.443 161.34 512 256 512C302.437 512 346.254 499.497 384 477.708V477.589L333.853 390.779C310.915 404.083 284.371 411.826 256 411.826Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 477.708V477.589L333.853 390.779C310.915 404.082 284.373 411.826 256 411.826V512C302.437 512 346.256 499.497 384 477.708Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.174 256C100.174 227.631 107.916 201.09 121.217 178.153L34.411 128.119C12.502 165.746 0 209.444 0 256C0 302.556 12.502 346.254 34.411 383.881L121.217 333.847C107.916 310.91 100.174 284.369 100.174 256Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 100.174C293.531 100.174 328.005 113.51 354.932 135.693C361.575 141.165 371.23 140.77 377.315 134.685L424.585 87.415C431.489 80.511 430.997 69.21 423.622 62.812C378.507 23.673 319.807 0 256 0C161.34 0 78.586 51.557 34.411 128.119L121.217 178.153C148.202 131.62 198.446 100.174 256 100.174Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.932 135.693C361.575 141.165 371.231 140.77 377.315 134.685L424.585 87.415C431.488 80.511 430.996 69.21 423.622 62.812C378.507 23.672 319.807 0 256 0V100.174C293.53 100.174 328.005 113.51 354.932 135.693Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.0af5e7bc401cefdff30fb1b7253f50d5.svg";
export { ForwardRef as ReactComponent };